import correosExpress from './logos/correos-express.svg';
import mrw from './logos/mrw.svg';
import mrwMSSII from './logos/mrw-mssii.svg';
import mrwCanarias from './logos/mrw-canarias.svg';
import mrwCanje from './logos/mrw-canje.svg';
import gls from './logos/gls.svg';
import glsMSSII from './logos/gls-mssii.svg';
import glsIt from './logos/gls-it.svg';
import glsDe from './logos/gls-de.svg';
import glsFr from './logos/gls-fr.svg';
import glsGm from './logos/gls-gl.svg';
import tipsa from './logos/tipsa.svg';
import tipsaCanje from './logos/tipsa-canje.svg';
import ctt from './logos/ctt.svg';
import transaher from './logos/transaher.png';
import ups from './logos/ups.svg';
import envialia from './logos/envialia.svg';
import dsvUps from './logos/dsv-ups.svg';
import dsvUpsDom from './logos/dsv-ups-dom.svg';
import dsvUpsDomDe from './logos/dsv-ups-dom_de.svg';
import dsvUpsDomIt from './logos/dsv-ups-dom_it.svg';
import dsvUpsEuIt from './logos/dsv-ups-eu_it.svg';
import dsvUpsDomFr from './logos/dsv-ups-dom_fr.svg';
import dsvUpsEuFr from './logos/dsv-ups-eu_fr.svg';
import dsvUpsEuDe from './logos/dsv-ups-eu_de.svg';
import dsvSeur from './logos/dsv-seur.svg';
import seur from './logos/seur.svg';
import dsvSeurBulkyDom from './logos/dsv-seur-bulky-dom.svg';
import dsvAmazonLogistics from './logos/dsv-amazon-logistics.svg';
import dsvOntimeEsBulk from './logos/dsv-ontime-es.svg';
import dsvPilot from './logos/dsv-pilot.svg';
import dsvAmazonHeavyBulky from './logos/dsv-amazon-heavy-bulky.svg';
import sfpDpd from './logos/sfp-dpd.svg';
import sfpSeur from './logos/sfp-seur.svg';
import sfpTnt from './logos/sfp-tnt.svg';
import sfpTntIt from './logos/sfp-tntit.svg';
import sfpFlex from './logos/AMZN_A3.svg';
import dpdFr from './logos/dpd-fr.svg';
import sfpChronopost from './logos/sfp-chronopost_fr.svg';
import oceanCourier from './logos/oceancourier.svg';
import paack from './logos/paack.svg';
import paackMSSII from './logos/paack-mssii.svg';
import aderGlobal from './logos/ader.svg';
import ontime from './logos/ontime.svg';
import ontimeMSSII from './logos/ontime-mssii.svg';
import mrwSollana from './logos/mrw-sollana.svg';
import upsSollana from './logos/ups-sollana.svg';
import dsvDhlDe from './logos/dhl-dsv-de.svg';
import ontimeCanje from './logos/ontime-canje.svg';
import dsvBrtIt from './logos/dsv-brt-it.svg';
import dsvGefcoFr from './logos/gefco-dsv-fr.svg';
import aderGlobalMSSII from './logos/ader-mssii.svg';
import method from './logos/method.svg';
import methodM2 from './logos/method-m2.svg';
import insideLogistics from './logos/inside-logistics.svg';
import amazonPrime from './logos/dsv-amazon-prime.svg';
import amazonStandard from './logos/dsv-amazon-standard.svg';
import xpo from './logos/xpo.svg';
import xpoC from './logos/xpo-c.svg';
import xpoR from './logos/xpo-r.svg';
import xpoL from './logos/xpo-lev.svg';
import asigna from './logos/asigna.svg';
import asignaGr from './logos/asigna-gr.svg';
import walden from './logos/walden-express.svg';
import RH from './logos/RH.svg';
import RHB from './logos/rhenus-biz.svg';
import RHM from './logos/rhenus-mrc.svg';
import RHV from './logos/rhenus-vlc.svg';
import RHC from './logos/rhenus-cat.svg';
import RHI from './logos/rhenus-can.svg';
import RHD from './logos/rhenus-mad.svg';
import RS from './logos/rhenus-sev.svg';
import RX from './logos/rhenus-x.svg';
import RHZ from './logos/rhenus-z.svg';
import RHT from './logos/rhenus-rt.svg';
import RHR from './logos/rhenus-rr.svg';
import RHDE from './logos/rhenus-d.svg';
import GOI from './logos/goi.svg';
import GOIAND from './logos/goi-and.svg';
import amzDsv from './logos/amzDsv.svg';
import amzSfp from './logos/amzSfp.svg';
import amzAuSh from './logos/AMZN_AT_SH.svg';
import amzAuShSd from './logos/AMZN_AT_SH_SD.svg';
import amzDeBulky from './logos/AMZN_DE_BULKY.svg';
import amzDeShSd from './logos/AMZN_DE_SH_SD.svg';
import amzFrSh from './logos/AMZN_FR_SH.svg';
import amzFrShSd from './logos/AMZN_FR_SH_SD.svg';
import amzItSh from './logos/AMZN_IT_SH.svg';
import amzItShSd from './logos/AMZN_IT_SH_SD.svg';
import amzFrDeShSd from './logos/AMZN_FR_DE_SH_SD.svg';
import amzFrDeBulky from './logos/AMZN_FR_DE_BULKY.svg';
import dhl from './logos/DHL.svg';
import dhlDePacket from './logos/DHL-ALEMANIA-PACKET.svg';
import dhlDeFridge from './logos/DHL-ALEMANIA-FRIDGE.svg';
import dhlDeWash from './logos/DHL-ALEMANIA-WASH.svg';
import brt from './logos/brt.svg';
import seurSm from './logos/seur-sm.svg';

/*
import correos from './logos/correos.svg';
import deutschePost from './logos/deutsche-post.svg';
import dhlExpress from './logos/dhl-express.svg';
import dhlParcel from './logos/dhl-parcel.png';
import fedex from './logos/fedex.svg';
import nacex from './logos/nacex.svg';
import schenker from './logos/schenker.svg';
import sending from './logos/sending.svg';
import seur from './logos/seur.svg';
import tnt from './logos/tnt.svg';
import zeleris from './logos/zeleris.svg';
import mix from './logos/zeleris.png';
*/

export const STATUSES = {
  READY: {
    name: 'READY',
    text: 'Listo para preparar',
    color: 'green',
    className: 'ready',
    allowedTo: ['can_print_labels', 'is_staff', 'is_warehouse_manager'],
  },
  PICKING: {
    name: 'PICKING',
    text: 'En preparación',
    color: 'yellow',
    className: 'picking',
    allowedTo: ['can_print_labels', 'is_staff', 'is_warehouse_manager'],
  },
  TRANSFER: {
    name: 'TRANSFER',
    text: 'Esperando traspaso',
    color: 'red',
    className: 'transfer',
    allowedTo: ['is_stock', 'is_staff', 'is_warehouse_manager'],
  },
  CLOSED: {
    name: 'CLOSED',
    text: 'Cerrado',
    color: 'grey',
    className: 'closed',
    allowedTo: ['can_reprint_labels', 'is_staff', 'is_warehouse_manager'],
  },
  INVALID: {
    name: 'INVALID',
    text: 'Erróneo',
    color: 'red',
    className: 'invalid',
    allowedTo: [],
  },
  FIXING: {
    name: 'FIXING',
    text: 'Pendiente de arreglo',
    color: 'yellow',
    className: 'fixing',
    allowedTo: [],
  },
  WAITING: {
    name: 'WAITING',
    text: 'En espera',
    color: 'orange',
    className: 'waiting',
    allowedTo: [],
  },
  FAILED: {
    name: 'FAILED',
    text: 'Fallo',
    color: 'red',
    className: 'failed',
    allowedTo: [],
  },
  SHIPPED: {
    name: 'SHIPPED',
    text: 'Envíado',
    color: 'green',
    className: 'shipped',
    allowedTo: [],
  },
};

export const MARKETPLACE_STATUSES = {
  '01': {
    name: '01',
    text: 'Pendiente B2B',
    color: 'yellow',
  },
  11: {
    name: '11',
    text: 'Error B2B',
    color: 'red',
  },
  13: {
    name: '13',
    text: 'Error obteniendo etiqueta',
    color: 'red',
  },
};

export const AGENCIES = {
  PK: {
    name: 'Paack',
    logo: {
      external: 'paack.png',
      internal: paack,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'paack',
  },
  P2: {
    name: 'Paack MSSII',
    logo: {
      external: 'paack-mssii.png',
      internal: paackMSSII,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'paack',
  },
  OT: {
    name: 'OnTime',
    logo: {
      external: 'ontime.png',
      internal: ontime,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'ontime',
  },
  O2: {
    name: 'OnTime MSSII',
    logo: {
      external: 'ontime-mssii.png',
      internal: ontimeMSSII,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'ontime',
  },
  OZ: {
    name: 'OnTime Canje',
    logo: {
      external: 'ontime-canje.png',
      internal: ontimeCanje,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'ontime',
  },
  AD: {
    name: 'Ader Global',
    logo: {
      external: 'ader.png',
      internal: aderGlobal,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'ader',
  },
  AM: {
    name: 'Ader Global MSSII',
    logo: {
      external: 'ader-mssii.png',
      internal: aderGlobalMSSII,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'ader',
  },
  CH: {
    name: 'Correos Express',
    logo: {
      external: 'correos-express.png',
      internal: correosExpress,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'correos-express',
  },
  MW: {
    name: 'MRW',
    logo: {
      external: 'mrw.png',
      internal: mrw,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b', 'lolina'],
    group: 'mrw',
  },
  M2: {
    name: 'MRW MSSII',
    logo: {
      external: 'mrw-mssii.png',
      internal: mrwMSSII,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'mrw',
  },
  MZ: {
    name: 'MRW Ecommerce Canje',
    logo: {
      external: 'mrw-canje.png',
      internal: mrwCanje,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'mrw',
  },
  MC: {
    name: 'MRW Canarias',
    logo: {
      external: 'mrw_canarias.png',
      internal: mrwCanarias,
    },
    allowedTo: ['scanpack', 'b2b'],
    group: 'mrw',
  },
  MS: {
    name: 'MRW Sollana',
    logo: {
      external: 'mrw-sollana.png',
      internal: mrwSollana,
    },
    allowedTo: ['scanpack', 'b2b'],
    group: 'mrw',
  },
  GL: {
    name: 'GLS',
    logo: {
      external: 'gls.png',
      internal: gls,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'gls',
  },
  G2: {
    name: 'GLS MSSII',
    logo: {
      external: 'gls-msii.png',
      internal: glsMSSII,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'gls',
  },
  GI: {
    name: 'GLS Italia',
    logo: {
      external: 'gls-it.png',
      internal: glsIt,
    },
    allowedTo: ['ollas', 'scanpack', 'b2b'],
    group: 'gls',
  },
  GG: {
    name: 'GLS Alemania',
    logo: {
      external: 'gls-de.png',
      internal: glsDe,
    },
    allowedTo: ['ollas', 'scanpack', 'b2b'],
    group: 'gls',
  },
  GF: {
    name: 'GLS Francia',
    logo: {
      external: 'gls-fr.png',
      internal: glsFr,
    },
    allowedTo: ['ollas', 'scanpack', 'b2b'],
    group: 'gls',
  },
  TI: {
    name: 'TIPSA',
    logo: {
      external: 'tipsa.png',
      internal: tipsa,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'tipsa',
  },
  TZ: {
    name: 'TIPSA Retorno',
    logo: {
      external: 'tipsa-canje.png',
      internal: tipsaCanje,
    },
    allowedTo: ['b2b', 'scanpack'],
    group: 'tipsa',
  },
  CT: {
    name: 'CTT',
    logo: {
      external: 'ctt.png',
      internal: ctt,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'ctt',
  },
  TR: {
    name: 'Transaher',
    logo: {
      external: 'transaher.png',
      internal: transaher,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'transaher',
  },
  UP: {
    name: 'UPS',
    logo: {
      external: 'ups.png',
      internal: ups,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'ups',
  },
  US: {
    name: 'UPS Sollana',
    logo: {
      external: 'ups-sollana.png',
      internal: upsSollana,
    },
    allowedTo: ['scanpack', 'b2b'],
    group: 'ups',
  },
  EN: {
    name: 'Envialia',
    logo: {
      external: 'envialia.png',
      internal: envialia,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'envialia',
  },
  DY: {
    name: 'DPD Francia',
    logo: {
      external: 'dpd-fr.png',
      internal: dpdFr,
    },
    allowedTo: ['ollas', 'scanpack', 'b2b'],
    group: 'dpd',
  },
  OC: {
    name: 'Ocean Courier',
    logo: {
      external: 'oceancourier.png',
      internal: oceanCourier,
    },
    allowedTo: ['ollas', 'scanpack', 'b2b'],
    group: 'ocean-courier',
  },
  DS: {
    name: 'DSV SEUR',
    logo: {
      external: 'dsv-seur.png',
      internal: dsvSeur,
    },
    allowedTo: ['dsv'],
    group: 'dsv',
  },
  DU: {
    name: 'DSV UPS',
    logo: {
      external: 'dsv-ups.png',
      internal: dsvUps,
    },
    allowedTo: ['dsv'],
    group: 'dsv',
  },
  DD: {
    name: 'DSV UPS DOM',
    logo: {
      external: 'dsv-ups-dom.png',
      internal: dsvUpsDom,
    },
    allowedTo: ['dsv'],
    group: 'dsv',
  },
  DK: {
    name: 'DSV UPS DOM DE',
    logo: {
      external: 'dsv-ups-dom_de.png',
      internal: dsvUpsDomDe,
    },
    allowedTo: ['dsv'],
    group: 'dsv',
  },
  DM: {
    name: 'DSV UPS DOM IT',
    logo: {
      external: 'dsv-ups-dom_it.png',
      internal: dsvUpsDomIt,
    },
    allowedTo: ['dsv'],
    group: 'dsv',
  },
  DO: {
    name: 'ES DSV ONTIME ES BULKY',
    logo: {
      external: 'dsv-ontime-es.png',
      internal: dsvOntimeEsBulk,
    },
    allowedTo: ['dsv'],
    group: 'dsv',
  },
  UI: {
    name: 'DSV UPS EU IT',
    logo: {
      external: 'dsv-ups-eu_it.png',
      internal: dsvUpsEuIt,
    },
    allowedTo: ['dsv'],
    group: 'dsv',
  },
  DF: {
    name: 'DSV UPS DOM FR',
    logo: {
      external: 'dsv-ups-dom_fr.png',
      internal: dsvUpsDomFr,
    },
    allowedTo: ['dsv'],
    group: 'dsv',
  },
  UF: {
    name: 'DSV UPS EU FR',
    logo: {
      external: 'dsv-ups-eu_fr.png',
      internal: dsvUpsEuFr,
    },
    allowedTo: ['dsv'],
    group: 'dsv',
  },
  UD: {
    name: 'DSV UPS EU DE',
    logo: {
      external: 'dsv-ups-eu_de.png',
      internal: dsvUpsEuDe,
    },
    allowedTo: ['dsv'],
    group: 'dsv',
  },
  DP: {
    name: 'Pilot',
    logo: {
      external: 'dsv-pilot.png',
      internal: dsvPilot,
    },
    allowedTo: ['dsv'],
    group: 'dsv',
  },
  DB: {
    name: 'DSV SEUR BULKY DOM',
    logo: {
      external: 'dsv-seur-bulky-dom.png',
      internal: dsvSeurBulkyDom,
    },
    allowedTo: ['dsv'],
    group: 'dsv',
  },
  DA: {
    name: 'DSV Amazon Logistics',
    logo: {
      external: 'dsv-amazon-logistics.png',
      internal: dsvAmazonLogistics,
    },
    allowedTo: ['dsv'],
    group: 'dsv',
  },
  DG: {
    name: 'DSV DHL AlEMANIA',
    logo: {
      external: 'dhl-dsv-de.png',
      internal: dsvDhlDe,
    },
    allowedTo: ['dsv'],
    group: 'dsv',
  },
  HB: {
    name: 'DSV Amazon Heavy Bulky',
    logo: {
      external: 'dsv-amazon-heavy-bulky.png',
      internal: dsvAmazonHeavyBulky,
    },
    allowedTo: ['dsv'],
    group: 'dsv',
  },
  A3: {
    name: 'SELLER FLEX SFP',
    logo: {
      external: 'AMZN_A3.png',
      internal: sfpFlex,
    },
    allowedTo: ['sfp'],
    group: 'sfp',
  },
  PS: {
    name: 'SFP SEUR',
    logo: {
      external: 'sfp-seur.png',
      internal: sfpSeur,
    },
    allowedTo: ['sfp'],
    group: 'sfp',
  },
  PD: {
    name: 'SFP DPD',
    logo: {
      external: 'sfp-dpd.png',
      internal: sfpDpd,
    },
    allowedTo: ['sfp'],
    group: 'sfp',
  },
  PI: {
    name: 'TNT ITALY',
    logo: {
      external: 'sfp-tntit.png',
      internal: sfpTntIt,
    },
    allowedTo: ['sfp'],
    group: 'sfp',
  },
  PT: {
    name: 'TNT',
    logo: {
      external: 'sfp-tnt.png',
      internal: sfpTnt,
    },
    allowedTo: ['sfp'],
    group: 'sfp',
  },
  CP: {
    name: 'SFP CHRONOPOST',
    logo: {
      external: 'sfp-chronopost_fr.png',
      internal: sfpChronopost,
    },
    allowedTo: ['sfp'],
    group: 'sfp',
  },
  BI: {
    name: 'DSV Bartolini IT',
    logo: {
      external: 'dsv-brt-it.png',
      internal: dsvBrtIt,
    },
    allowedTo: ['dsv'],
    group: 'dsv',
  },
  GV: {
    name: 'DSV GEFCO FR',
    logo: {
      external: 'gefco-dsv-fr.png',
      internal: dsvGefcoFr,
    },
    allowedTo: ['dsv'],
    group: 'dsv',
  },
  D3: {
    name: 'FR DSV AMZN DE SH SD',
    logo: {
      external: 'AMZN_FR_DE_SH_SD.png',
      internal: amzFrDeShSd,
    },
    allowedTo: ['dsv'],
    group: 'dsv',
  },
  D4: {
    name: 'DSV FR DSV AMZN DE BULKY',
    logo: {
      external: 'AMZN_FR_DE_BULKY.png',
      internal: amzFrDeBulky,
    },
    allowedTo: ['dsv'],
    group: 'dsv',
  },
  SE: {
    name: 'SEUR',
    logo: {
      external: 'seur.png',
      internal: seur,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'seur',
  },
  ME: {
    name: 'METHOD',
    logo: {
      external: 'method.png',
      internal: method,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'method',
  },
  AP: {
    name: 'AMAZON DSV PRIME',
    logo: {
      external: 'dsv-amazon-prime.png',
      internal: amazonPrime,
    },
    allowedTo: ['dsv'],
    group: 'dsv',
  },
  AS: {
    name: 'AMAZON DSV STANDARD',
    logo: {
      external: 'dsv-amazon-standard.png',
      internal: amazonStandard,
    },
    allowedTo: ['dsv'],
    group: 'dsv',
  },
  XP: {
    name: 'XPO',
    logo: {
      external: 'xpo.png',
      internal: xpo,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'xpo',
  },
  XC: {
    name: 'XPO Catalunya',
    logo: {
      external: 'xpo-c.png',
      internal: xpoC,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'xpo',
  },
  XL: {
    name: 'XPO Levante',
    logo: {
      external: 'xpo-lev.png',
      internal: xpoL,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'xpo',
  },
  XR: {
    name: 'XPO Resto',
    logo: {
      external: 'xpo-r.png',
      internal: xpoR,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'xpo',
  },
  AZ: {
    name: 'ASIGNA',
    logo: {
      external: 'asigna.png',
      internal: asigna,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'asigna',
  },
  WA: {
    name: 'Walden Express',
    logo: {
      external: 'walden-express.png',
      internal: walden,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'walden',
  },
  WD: {
    name: 'Walden Express',
    logo: {
      external: 'walden-express.png',
      internal: walden,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'walden',
  },
  WB: {
    name: 'Walden Express Brie',
    logo: {
      external: 'walden-express.png',
      internal: walden,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'walden',
  },
  RV: {
    name: 'Rhenus Logistics VLC',
    logo: {
      external: 'RH.png',
      internal: RHV,
    },
    allowedTo: ['scanpack', 'sat', 'b2b'],
    group: 'rhenus-logistics',
  },
  RB: {
    name: 'Rhenus Logistics BIZ',
    logo: {
      external: 'RH.png',
      internal: RHB,
    },
    allowedTo: ['scanpack', 'sat', 'b2b'],
    group: 'rhenus-logistics',
  },
  RH: {
    name: 'Rhenus Logistics MRC',
    logo: {
      external: 'RH.png',
      internal: RHM,
    },
    allowedTo: ['scanpack', 'sat', 'b2b'],
    group: 'rhenus-logistics',
  },
  RC: {
    name: 'Rhenus Logistics Catauña',
    logo: {
      external: 'RH.png',
      internal: RHC,
    },
    allowedTo: ['scanpack', 'sat', 'b2b'],
    group: 'rhenus-logistics',
  },
  RI: {
    name: 'Rhenus Logistics Canarias',
    logo: {
      external: 'RH.png',
      internal: RHI,
    },
    allowedTo: ['scanpack', 'sat', 'b2b'],
    group: 'rhenus-logistics',
  },
  RM: {
    name: 'Rhenus Logistics Madrid',
    logo: {
      external: 'RH.png',
      internal: RHD,
    },
    allowedTo: ['scanpack', 'sat', 'b2b'],
    group: 'rhenus-logistics',
  },
  RP: {
    name: 'Rhenus Logistics Sevilla',
    logo: {
      external: 'RH.png',
      internal: RS,
    },
    allowedTo: ['scanpack', 'sat', 'b2b'],
    group: 'rhenus-logistics',
  },
  RX: {
    name: 'Rhenus Logistics Otros',
    logo: {
      external: 'RH.png',
      internal: RX,
    },
    allowedTo: ['scanpack', 'sat', 'b2b'],
    group: 'rhenus-logistics',
  },
  GO: {
    name: 'GOI',
    logo: {
      external: 'goi.png',
      internal: GOI,
    },
    allowedTo: ['scanpack', 'sat', 'b2b'],
    group: 'goi',
  },
  GA: {
    name: 'GOI Andalucia',
    logo: {
      external: 'goi-and.png',
      internal: GOIAND,
    },
    allowedTo: ['scanpack', 'sat', 'b2b'],
    group: 'goi',
  },
  A1: {
    name: 'Amazon Austria SH',
    logo: {
      external: 'AMZ-AU-SH.png',
      internal: amzAuSh,
    },
    allowedTo: ['dsv'],
    group: 'dsv',
  },
  A2: {
    name: 'Amazon Austria SH SD',
    logo: {
      external: 'AMZ-AU-SH-SD.png',
      internal: amzAuShSd,
    },
    allowedTo: ['dsv'],
    group: 'dsv',
  },
  D1: {
    name: 'Amazon Alemania Bulky',
    logo: {
      external: 'AMZ-DE-BULKY.png',
      internal: amzDeBulky,
    },
    allowedTo: ['dsv'],
    group: 'dsv',
  },
  D2: {
    name: 'Amazon Alemania SH SD',
    logo: {
      external: 'AMZ-DE-SH-SD.png',
      internal: amzDeShSd,
    },
    allowedTo: ['dsv'],
    group: 'dsv',
  },
  F1: {
    name: 'Amazon Francia SH',
    logo: {
      external: 'AMZ-FR-SH.png',
      internal: amzFrSh,
    },
    allowedTo: ['dsv'],
    group: 'dsv',
  },
  GB: {
    name: 'GLS Francia',
    logo: {
      external: 'gls-fr.png',
      internal: glsFr,
    },
    allowedTo: ['ollas', 'sat', 'scanpack', 'b2b'],
    group: 'gls',
  },
  GM: {
    name: 'GLS Internacional',
    logo: {
      external: 'gls-gl.png',
      internal: glsGm,
    },
    allowedTo: ['ollas', 'sat', 'scanpack', 'b2b'],
    group: 'gls',
  },
  RD: {
    name: 'Rhenus Descanso',
    logo: {
      external: 'rhenus-d.png',
      internal: RHDE,
    },
    allowedTo: ['scanpack', 'sat', 'b2b'],
    group: 'rhenus-logistics',
  },
  RR: {
    name: 'Rhenus Logistics Italia',
    logo: {
      external: 'rhenus-rr.png',
      internal: RHR,
    },
    allowedTo: ['scanpack', 'sat', 'b2b'],
    group: 'rhenus-logistics',
  },
  RT: {
    name: 'Rhenus RHENUS',
    logo: {
      external: 'rhenus-rt.png',
      internal: RHT,
    },
    allowedTo: ['scanpack', 'sat', 'b2b'],
    group: 'rhenus-logistics',
  },
  RZ: {
    name: 'Rhenus canje',
    logo: {
      external: 'rhenus-z.png',
      internal: RHZ,
    },
    allowedTo: ['scanpack', 'sat', 'b2b'],
    group: 'rhenus-logistics',
  },
  F2: {
    name: 'Amazon Francia SH SD',
    logo: {
      external: 'AMZ-FR-SH-SD.png',
      internal: amzFrShSd,
    },
    allowedTo: ['dsv'],
    group: 'dsv',
  },
  I1: {
    name: 'Amazon Italia SH',
    logo: {
      external: 'AMZ-IT-SH.png',
      internal: amzItSh,
    },
    allowedTo: ['dsv'],
    group: 'dsv',
  },
  I2: {
    name: 'Amazon Italia SH SD',
    logo: {
      external: 'AMZ-IT-SH-SD.png',
      internal: amzItShSd,
    },
    allowedTo: ['dsv'],
    group: 'dsv',
  },
  AY: {
    name: 'ASIGNA GRANADILLAS',
    logo: {
      external: 'asigna-gr.png',
      internal: asignaGr,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'asigna',
  },
  MO: {
    name: 'METHOD MSS2',
    logo: {
      external: 'method-m2.png',
      internal: methodM2,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'method',
  },
  II: {
    name: 'INSIDE LOGISTICS',
    logo: {
      external: 'II.png',
      internal: insideLogistics,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'inside',
  },
  DH: {
    name: 'DHL Wash',
    logo: {
      external: 'DHL-ALEMANIA-WASH.png',
      internal: dhlDeWash,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'dhl',
  },
  DL: {
    name: 'DHL Fridge',
    logo: {
      external: 'II.png',
      internal: dhlDeFridge,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'dhl',
  },
  DC: {
    name: 'DHL Packet',
    logo: {
      external: 'DHL-ALEMANIA-PACKET.png',
      internal: dhlDePacket,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'dhl',
  },
  BA: {
    name: 'Bartolini',
    logo: {
      external: 'Brt.png',
      internal: brt,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'bartolini',
  },
  SM: {
    name: 'Seur MediaMarkt',
    logo: {
      external: 'seur-sm.png',
      internal: seurSm,
    },
    allowedTo: ['ollas', 'scanpack', 'sat', 'b2b'],
    group: 'seur',
  },
};

export const GROUP_LOGOS = {
  paack: paack,
  ontime: ontime,
  ader: aderGlobal,
  'correos-express': correosExpress,
  mrw: mrw,
  gls: gls,
  tipsa: tipsa,
  ctt: ctt,
  transaher: transaher,
  ups: ups,
  envialia: envialia,
  'ocean-courier': oceanCourier,
  seur: seur,
  dsv: amzDsv,
  'rhenus-logistics': RH,
  sfp: amzSfp,
  dpd: dpdFr,
  xpo: xpo,
  asigna: asigna,
  method: method,
  walden: walden,
  goi: GOI,
  dhl: dhl,
  bartolini: brt,
};

export const ORIGINS = {
  B2B: {
    name: 'B2B',
    slug: 'b2b',
    className: 'b2b',
    color: 'teal',
  },
  STOCK: {
    name: 'Stock',
    slug: 'stock',
    className: 'stock',
    color: 'blue',
    hidden: true,
  },
  SAT: {
    name: 'SAT',
    slug: 'sat',
    className: 'sat',
    color: 'violet',
  },
  OLLAS: {
    name: 'Ollas GM',
    slug: 'ollas',
    className: 'ollas',
    color: 'purple',
  },
  SCANPACK: {
    name: 'Scan & Pack',
    slug: 'scanpack',
    className: 'scanpack',
    color: 'pink',
  },
  BULKDROP: {
    name: 'BulkDrop',
    slug: 'bulkdrop',
    className: 'bulkdrop',
    color: 'brown',
  },
  LOLINA: {
    name: 'Lolina',
    slug: 'lolina',
    className: 'lolina',
    color: 'pink',
  },
  DSV: {
    name: 'DSV',
    slug: 'dsv',
    className: 'dsv',
    color: 'orange',
  },
  SFP: {
    name: 'SFP',
    slug: 'sfp',
    className: 'sfp',
    color: 'blue',
  },
  SORTER: {
    name: 'Sorter',
    slug: 'sorter',
    className: 'sorter',
    color: 'brown',
  },
  STAFF: {
    name: 'Staff',
    slug: 'staff',
    className: 'staff',
    color: 'grey',
    hidden: true,
  },
  ADMIN: {
    name: 'Admin',
    slug: 'admin',
    className: 'admin',
    color: 'grey',
    hidden: true,
  },
};

export const ITEMS_PER_PAGE = 50;

export const INDEXED_DB = {
  name: 'dropshipments',
  objectStoreNames: {
    configuration: 'configuration',
  },
};

export const REDIRECTABLE_ERROR_TYPES = [
  'preparation_order.picked_by_another_user',
  'preparation_order.pending_another_agency',
  'preparation_order.no_stock_user_can_not_pick',
  'user.undefined_workstation',
];
